export function councilNumberFromSession(session) {
  if (!session) return null;
  if (session.councilNumber != null && session.councilNumber !== '') {
    return Number(session.councilNumber);
  }
  const type = String(session.sessionType || '');
  if (!/^council/i.test(type)) return null;
  const match = type.match(/\d+/);
  return match ? Number(match[0]) : null;
}

export function isCouncilSession(session) {
  return councilNumberFromSession(session) != null;
}

export function isOrientationSession(session) {
  return String(session?.sessionType || '').toLowerCase().startsWith('orientation');
}

export function sessionStatusKey(status) {
  return String(status || '').toLowerCase();
}

/** Nominations editable unless cancelled (live/planned/completed all allowed). */
export function isCouncilNominationEditable(session) {
  const status = sessionStatusKey(session?.status);
  return status !== 'cancelled';
}

export function councilNominationsComplete(squads = []) {
  if (!squads.length) return false;
  return squads.every((squad) => squad.chair_student_id != null && squad.chair_student_id !== '');
}

export function studentLabel(students, id) {
  if (id == null || id === '') return '—';
  const row = (students || []).find((s) => String(s.id) === String(id));
  return row?.name || `#${id}`;
}

export function hoursUntilSession(scheduledAt) {
  if (!scheduledAt) return 72;
  const target = new Date(scheduledAt).getTime();
  if (Number.isNaN(target)) return 72;
  return Math.max(1, Math.round((target - Date.now()) / (1000 * 60 * 60)));
}